import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const CardsActionLazy = loadable(() => import(/* webpackChunkName: "Collections" */ './CardsAction'));

export const CardsActionAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <CardsActionLazy />
    </DelayedSuspense>
);
